import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useHistory } from "react-router";

import HeroImg from "../../images/template-hero.png";
import HeroBanner from "../../images/template-hero.jpg";

import Head from "../../components/Head/Head";
import NavBar from "../../components/NavBar/NavBar";
import ContactUs from "../../components/Forms/ContactUs/ContactUs";
import Footer from "../../components/Footer/Footer";
import Prefer from "../../components/Prefer/Prefer";
import Offices from "../../components/Offices/Offices";
import InstantQuote from "../../components/InstantQuote/InstantQuote";

import companies from "../../data/companies";

import "./Compare.css";

const Document = ({ match }) => {
  const history = useHistory();
  const company = match.params.company
    .split("")
    .map((letter, i) => {
      if (i === 0) return letter.toUpperCase();
      else return letter;
    })
    .join("")
    .split("-")
    .join(" ");
  const [show, setShow] = useState(false);
  const findCompany = (loc) => {
    return (
      loc.split(/[-' ]/).join(" ").toLowerCase() ===
      company.split(/[-' ]/).join(" ").toLowerCase()
    );
  };
  const getCompany = companies.find(findCompany);

  useEffect(() => {
    if (getCompany) setShow(true);
    else history.replace("/404");
  }, [getCompany, history]);

  return (
    <>
      {show && (
        <div className="template position-relative">
          <Head
            title={`Oneconverse VS ${company.charAt(0)}${company.slice(1)}`}
            description={
              "Oneconverse is a trusted translation & interpretation agency. Go global with our certified translation, interpretation services, and translators near you."
            }
            keywords={`translation, interpretation, certified, services, language, conference interpreter, document, localization, translators, interpreter, translator, translation company, translation services, translation companies, translation agencies, document translation, translation services near me, translate document, document translation service, document translation services online, simultaneous interpretation services, multilingual services, sworn translators, certified translations, ${company}`}
          />
          <NavBar />
          <div className="template__hero container overflow-hidden d-flex f-50 align-center justify-between position-relative z-1">
            <div className="f-50 my-40">
              <div className="d-flex flex-column align-start justify-center">
                <h2 className="text-capitalise font-heading text-capitalise">
                  Check as OneConverse compare with {company}
                </h2>
                <p className="font-bigger mt-40">
                  We offer quality sevices, with a tall reputation in the
                  industry that speak for us
                </p>
                <a
                  href="/quote"
                  className="template__link mt-40 py-10 px-20 font-bold"
                >
                  REQUEST A QUOTE
                </a>
              </div>
            </div>
            <div className="d-flex flex-row-reverse justify-end overflow-hidden f-50">
              <img className="d-flex" src={HeroImg} alt="" />
            </div>
          </div>
          <img className="template__banner my-20" src={HeroBanner} alt="" />
          <div className="template__sec1 container d-flex flex-column align-start justify-between">
            <div className="">
              <h2 className="text-capitalise font-heading">
                {company} Alternative
              </h2>
              <h3 className="my-20 font-bigger">OneConverse LLC</h3>
              <ul className="my-20 font-heavy ml-20">
                <li className="font-big">
                  <span className="font-bold">Website:</span>{" "}
                  www.oneconverse.com
                </li>
                <li className="font-big">
                  <span className="font-bold">Global presence:</span> 250
                  Countries
                </li>
                <li className="font-big">
                  <span className="font-bold">Number of translators:</span>{" "}
                  50,000+
                </li>
                <li className="font-big">
                  <span className="font-bold">Rating:</span> 5stars from over
                  7,500 reviews
                </li>
              </ul>
              <Link
                to="/quote"
                className="template__link my-40 py-10 px-20 font-bold"
              >
                REQUEST A QUOTE
              </Link>
            </div>
          </div>
          <div className="template__sec3 container d-flex flex-column-reverse align-center justify-between f-100">
            <div className="f-50">
              <div>
                <h2 className="text-capitalise font-heading py-40">
                  Comparing OneConverse Vs {company}
                </h2>
                <p className="lh-lg my-10 font-heavy">
                  Oneconverse vs {company} has been an on-going debate amongst
                  top professionals in the translation business. With so many
                  top competitors, Oneconverse must stand out from the crowd if
                  it is to stay on top. The challenge for this top company is to
                  find ways of making itself stand out from its main competitor,{" "}
                  {company}. This article will outline how Oneconverse stands up
                  against its top competitor, {company}. Top companies are
                  always searching for top talent and new hires are often
                  required to take exams before being allowed into certain
                  divisions or departments of a company. Because of this need
                  for top talent, competition becomes fierce as businesses are
                  constantly looking for the best way to attract top translators
                  . both top companies, having quality work to offer top talent,
                  will often pay top dollar for top talents.{" "}
                </p>
                <p className="lh-lg my-10 font-heavy">
                  Oneconverse Translation company has launched an online project
                  to attract top talent and promote their services. {company} ,
                  in turn, has created a social media presence by way of
                  LinkedIn . Both companies are top competitors when it comes to
                  providing top quality translation services in the business
                  world. They both provide certified translations in many
                  languages including German, Italian, French, Greek,
                  Portuguese, Spanish Arabic and Russian among others. The main
                  difference lies between the customer service offered at each
                  establishment when dealing with top clients who sometimes
                  demand expedient completion of projects. Oneconverse
                  Translation is able to cope with impatient clients better
                  because they are more flexible in setting deadlines which
                  projects must be completed. Top clients who need top quality
                  top translations top often have very little time to wait
                  before the work is necessary. {company} Translation , on the
                  other hand, has been known to push back deadlines by as much
                  as a day or two which can be quite aggravating for top clients
                  who just want their projects completed as soon as possible.{" "}
                </p>
                <p className="lh-lg my-10 font-heavy">
                  The process of translation is not an easy one and can be very
                  time-consuming especially when it comes to longer texts or
                  documents. For this reason, most businesses are turning
                  towards professional translators who have the necessary
                  skillset to translate text with accuracy and at a reasonable
                  cost. Business document translation service in {company} is
                  one of the most important aspects today. More and more
                  companies are looking for a top document translation service
                  provider in {company} to make their products reach the global
                  audience.
                </p>
              </div>
            </div>
          </div>
          <div className="template__sec3 container d-flex flex-column-reverse align-center justify-between f-100">
            <div className="f-50">
              <div>
                <h2 className="text-capitalise font-heading py-40">
                  Oneconverse stands out from its top competitor in many ways{" "}
                </h2>
                <p className="lh-lg my-10 font-heavy">
                  Their top project managers are well-versed in many languages
                  which allows them to communicate with top translators and
                  clients alike. They currently employ over 50,000 certified top
                  translators around the world . Their prices are reasonable &
                  they offer discounts for top referrals and repeat business.
                  Oneconverse also offers top of the technology translation,
                  localization and conference interpretation, and Premium CAT
                  tools which top translators often require in order to complete
                  top translations.
                </p>
                <p className="lh-lg my-10 font-heavy">
                  {company} Translation Company is a top competitor to
                  Oneconverse Translation. They were founded in 1990 and have
                  since become a top provider of certified translations with
                  over 3,000 employees in 90 offices worldwide. Like
                  Oneconverse, they also offer top quality translations in many
                  languages. The main difference between these top two companies
                  is the customer service that they provide. {company} is not as
                  flexible as Oneconverse when it comes to setting deadlines for
                  top clients which can be quite frustrating for top clients who
                  need their work completed as soon as possible. In addition,{" "}
                  {company} does not have the same technological capabilities as
                  Oneconverse which can make it difficult for top translators to
                  complete top projects when top companies are not up to speed
                  when it comes to top technology.{" "}
                </p>
              </div>
            </div>
          </div>
          <div className="template__sec3 container d-flex flex-column-reverse align-center justify-between f-100">
            <div className="f-50">
              <div>
                <h2 className="text-capitalise font-heading py-40">
                  Oneconverse interpretation company offers top quality services
                  in many languages
                </h2>
                <p className="lh-lg my-10 font-heavy">
                  Their top project managers have the ability to communicate
                  with top clients in order to manage top projects in a
                  professional manner. They currently employ over 50,000
                  certified top translators around the world which makes them a
                  top competitor for
                  {company} Translation Company. One of their main differences
                  lies between the flexibility they offer in setting deadlines
                  for top clients who are often very demanding when it comes
                  time constraints on top projects that must be completed
                  quickly. Oneconverse is much more flexible than {company} when
                  it comes to this aspect of business whereas {company} can
                  become quite rigid about meeting deadlines . In addition,
                  Oneconverse offers top of the line technology for top
                  translators to use when completing top translations. This
                  gives them an edge over
                  {company} who sometimes falls behind in terms of technological
                  advances.{" "}
                </p>
                <p className="lh-lg my-10 font-heavy">
                  Both Oneconverse Translation and {company} Translation are top
                  competitors when it comes to providing top quality
                  translations. They both offer certified translations in many
                  languages and have a global presence with offices in many
                  countries worldwide. The main difference between the two
                  companies is the customer service that they provide.
                  Oneconverse is more flexible than {company}
                  when it comes to setting deadlines for top clients which can
                  be quite frustrating for top clients who need their work
                  completed as soon as possible. In addition, Oneconverse offers
                  top of the line technology for top translators to use when
                  completing top translations. This gives them an edge over{" "}
                  {company} who sometimes falls behind in terms of technological
                  advances.{" "}
                </p>
              </div>
            </div>
          </div>
          <div className="template__sec3 container d-flex flex-column-reverse align-center justify-between f-100">
            <div className="f-50">
              <div>
                <h2 className="text-capitalise font-heading py-40">
                  Oneconverse top translation company stands out from top
                  competitor
                  {company} Translation Company.{" "}
                </h2>
                <p className="lh-lg my-10 font-heavy">
                  They offer top quality translations and have a global presence
                  with offices located in many countries worldwide. Oneconverse
                  is known to be more flexible than top competitor {company}{" "}
                  when it comes to setting deadlines for top clients which can
                  be quite frustrating for top companies who need their work
                  completed as soon as possible.. On the other hand, Oneconverse
                  also offers top of the line technology such as Trados Studio
                  2011 which top translators often require in order to complete
                  top translations.{" "}
                </p>
                <p className="lh-lg my-10 font-heavy">
                  Oneconverse Translation, a top translation company with a
                  global presence and offices in many countries worldwide,
                  offers top quality translations as well as top customer
                  service. They are known to be more flexible than top
                  competitor {company}
                  Translation when it comes to setting deadlines for top clients
                  which can be quite frustrating for top companies who need
                  their work completed as soon as possible. In addition,
                  Oneconverse offers top of the line technology for top
                  translators to use when completing top translations. This
                  gives them an edge over
                  {company} who sometimes falls behind in terms of technological
                  advances.{" "}
                </p>
              </div>
            </div>
          </div>
          <div className="template__sec3 container d-flex flex-column-reverse align-center justify-between f-100">
            <div className="f-50">
              <div>
                <h2 className="text-capitalise font-heading py-40">
                  Customer support ratings: Oneconverse vs {company}{" "}
                </h2>
                <p className="lh-lg my-10 font-heavy">
                  When it comes to customer care support, OneConverse is the
                  clear winner. They offer 24-hour support through a live chat
                  and e-ticketing system, which ensures that clients from all
                  over the world receive premium support. {company} offers
                  significantly less customer care support, with no live chat
                  option and only limited e-ticketing hours. This makes
                  OneConverse the top translation company for customer care
                  support.{" "}
                </p>
                <p className="lh-lg my-10 font-heavy">
                  Certified translation companies are essential for businesses
                  that need to translate important documents into other
                  languages. OneConverse is a certified translation company that
                  has been providing quality translations for years. {company}{" "}
                  is not a certified translation company, meaning that their
                  translations may not be as accurate or reliable as those
                  provided by OneConverse. This makes OneConverse the top
                  translation company for certified translations.{" "}
                </p>
                <p className="lh-lg my-10 font-heavy">
                  When it comes to top translation company, no one can compete
                  with OneConverse. They are top rated on all major review sites
                  because of their commitment to excellence and customer
                  satisfaction.
                  {company} has an average rating because they have not received
                  positive reviews from customers in the past. This makes
                  OneConverse top translation company when it comes to top rated
                  translation services.{" "}
                </p>
              </div>
            </div>
          </div>
          <div className="template__sec3 container d-flex flex-column-reverse align-center justify-between f-100">
            <div className="f-50">
              <div>
                <h2 className="text-capitalise font-heading py-40">
                  OneConverse vs {company} Pricing- Which is best in terms of
                  affordability?{" "}
                </h2>
                <p className="lh-lg font-heavy">
                  If you need reliable translations at affordable rates, choose
                  top rated translation companies like OneConverse . When you
                  choose top rated translation companies, you get quality
                  translations while still keeping costs low. So if you're
                  looking for high-quality translations services without
                  spending a fortune, OneConverse is the best option for you.
                </p>
                <p className="lh-lg font-heavy">
                  Oneconverse is a top translation company based in the United
                  State. This top company offers many different types of
                  language services including professional interpreting
                  services, multilingual SEO strategies at competitive rates and
                  top quality translations from top professionals.{" "}
                </p>
              </div>
            </div>
          </div>
          <div className="template__sec3 container d-flex flex-column-reverse align-center justify-between f-100">
            <div className="f-50">
              <div>
                <h2 className="text-capitalise font-heading py-40">
                  {company} vs OneConverse: Which one is better?{" "}
                </h2>
                <p className="lh-lg font-heavy">
                  In this article we are going to talk about two top companies
                  that provide high level translation services: {company} , the
                  best translation company, and OneConverse. Both of these top
                  translation companies are certified and have a great
                  reputation in the market. They offer an extensive range of
                  language services that can meet any business need. However,
                  when it comes to customer satisfaction, OneConverse is the
                  clear winner.{" "}
                </p>
                <p className="lh-lg font-heavy">
                  The reason for this is that OneConverse really takes care of
                  its clients and always goes above and beyond to make sure they
                  are happy with the service they receive. {company} is a great
                  translation company, but it doesn’t quite match up to the high
                  standards set by OneConverse . If you need a top quality
                  translation service, then we recommend choosing OneConverse
                  without a doubt.{" "}
                </p>
              </div>
            </div>
          </div>
          <div className="template__sec3 container d-flex flex-column-reverse align-center justify-between f-100">
            <div className="f-50">
              <div>
                <h2 className="text-capitalise font-heading py-40">
                  The best to work with; OneConverse Vs {company}{" "}
                </h2>
                <h2 className="text-capitalise font-heading py-40">
                  Many translators find Oneconverse has the best company to work
                  with than {company}{" "}
                </h2>
                <p className="lh-lg font-heavy">
                  There is no denying that there are brands that have a global
                  audience and need a translation service. OneConverse is one of
                  the prominent providers of translation services in the market.
                  They are a certified translation company with over 10 years of
                  experience and more than 50,000 translators in their network.{" "}
                </p>
                <p className="lh-lg font-heavy">
                  It is important to note that some translators may have more
                  experience with OneConverse than {company}. This can be
                  attributed to the fact that OneConverse has been around for
                  longer, which means they have had time to establish their
                  services and standards across a wider range of languages and
                  countries.{" "}
                </p>
                <p className="lh-lg font-heavy">
                  Both these agencies are some of the best in the industry, but
                  it is the certified translation company's experience with
                  OneConverse that sets them apart.{" "}
                </p>
                <p className="lh-lg font-heavy">
                  OneConverse has been around for a while and it is well-known
                  for its fast translations and easy to use platform. {company},
                  on the other hand, is new to the game and they are a bit more
                  on the expensive side.{" "}
                </p>
                <p className="lh-lg font-heavy">
                  There are many ways in which OneConverse stands out from the
                  pack, including quality and price, but it is not the only
                  thing that sets them apart from their competitors.{" "}
                </p>
                <p className="lh-lg font-heavy">
                  When it comes to document translation services, OneConverse
                  clearly dominates over {company}. This is because of their
                  experience in dealing with various challenges that arise
                  during translation. They have a higher translation volume and
                  had a better success rate when it comes to document
                  translations.{" "}
                </p>
                <p className="lh-lg font-heavy">
                  OneConverse has also been consistently improving its product
                  since its launch in 2009. In contrast, {company} has been
                  around for much longer but hasn’t made any significant
                  improvements to their product or services.
                </p>
              </div>
            </div>
          </div>
          <Prefer />
          <Offices />
          <ContactUs />
          <div className="container">
            <InstantQuote />
          </div>
          <Footer />
        </div>
      )}
    </>
  );
};

export default Document;
